<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import projetoServico from '~modulos/projeto/servico';
  import detalheRateioServico from '~modulos/detalhe-rateio/servico';
  import tiposQuadro from '~js/tipos-quadro';
  import pessoaServico from '~modulos/acessos/servico';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      desabilitarBeneficiario: {
        type: Boolean,
        default: false,
      },
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        contas: [],
        detalheRateios: [],
        tiposQuadro: tiposQuadro,
        metaEtapas: [],
        rubricas: [],
        subrubricas: [],
        configuracao: this.$storage.configuracao(),
        desabilitarEndereco: false,
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolPagamentoPessoaJuridica")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contas(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      listaDeDetalheRateio() {
        detalheRateioServico
          .lista()
          .then(detalheRateios => {
            this.detalheRateios = detalheRateios;
          });
      },
      listaDeMetaEtapas(idProjeto) {
        projetoServico
          .metaEtapas(idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas(idProjeto) {
        this.solicitacao.idRubrica = '';
        this.solicitacao.idSubrubrica = '';
        this.subrubricas = [];

        if (this.solicitacao.rateio.projeto.utilizarMetaEtapaProjeto) {
          return projetoServico
            .rubricas(idProjeto, this.solicitacao.rateio.idProjetoMetaEtapa)
            .then(rubricas => {
              this.rubricas = rubricas;
            });
        }
        else {
          return projetoServico
            .rubricas(idProjeto)
            .then(rubricas => {
              this.rubricas = rubricas;
            });
        }
      },
      listaDeSubrubricas(idProjeto = null, idRubrica = null) {
        idProjeto = this.solicitacao.rateio.projeto.idProjeto || idProjeto;
        idRubrica = this.solicitacao.idRubrica || idRubrica;

        this.solicitacao.idSubrubrica = '';
        this.subrubricas = [];

        if (!idRubrica) return;

        if (this.solicitacao.rateio.projeto.utilizarMetaEtapaProjeto) {
          return projetoServico
            .subrubricas(idProjeto, idRubrica, this.solicitacao.rateio.idProjetoMetaEtapa)
            .then(subrubricas => {
              this.subrubricas = subrubricas;
            });
        }
        else {
          return projetoServico
            .subrubricas(idProjeto, idRubrica)
            .then(subrubricas => {
              this.subrubricas = subrubricas;
            });
        }
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao.rateio, 'projeto', projeto);
            this.solicitacao.compraDireta = false;
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function(e) {
            _this.$set(_this.solicitacao.rateio, 'idProjeto', this.value);

            _this.setarProjeto(this.value);


            if (!this.value) return;

            _this.$set(_this.solicitacao, 'idConta', '');
            _this.$set(_this.solicitacao.rateio, 'idProjetoMetaEtapa', '');
            
            if (_this.configuracao.selecaoDeContaWeb) {
              _this.listaContas(this.value);
            }
            
            if (_this.solicitacao.rateio.projeto.utilizarMetaEtapaProjeto) {
              _this.listaDeMetaEtapas(this.value);
            } else {
              _this.listaDeRubricas(this.value);
            }
          });
      },
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      retiraClasseRequired() {

        if (this.configuracao.solPagamentoMenosRestricao == 1) {
          $('#dEndereco').removeClass('required');
          $('#dNumero').removeClass('required');
          $('#dBairro').removeClass('required');
          $('#dCidade').removeClass('required');
          $('#dUf').removeClass('required');
          $('#dCep').removeClass('required');
          $('#dTelefone-residencial').removeClass('required');
          $('#dEmail-terceiro').removeClass('required');
        }

      },
      getCEP() {
        if (this.carregando) return;

        let textoCEP = this.solicitacao.cep.replace('-', '').replace('.', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.solicitacao.endereco = cepObj.logradouro.substring(0, 60);
              this.solicitacao.bairro = cepObj.bairro.substring(0, 60);
              this.solicitacao.cidade = cepObj.localidade.substring(0, 60);
              this.solicitacao.uf = cepObj.uf;
              this.solicitacao.numero = "";
              this.solicitacao.complemento = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      },
    },
    computed: {
      validarConta() {
        return this.configuracao.selecaoDeContaWeb ? 'required' : '';
      },
      validarDetalheRateio() {
        return this.configuracao.utilizarDetalheRateioSolicitacao ? 'required' : '';
      },
      exibirRubricaSubrubricaSolicitacaoWeb() {
        return this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || this.solicitacao.rateio.projeto.utilizarRubricaSubrubricaWeb;
      }
    },
    mounted() {
      $('label.checkbox')
        .css('margin-top', 0)
        .css('margin-bottom', 5)
        .addClass('control-label');

      this.listaDeProjetos();
      this.iniciarSelect2Projeto();
      this.retiraClasseRequired();

      if (this.configuracao.utilizarDetalheRateioSolicitacao) {
        this.listaDeDetalheRateio();
      }
    },
    updated(){
        const _this = this;

        this.$watch('solicitacao.cep', function () {
        _this.getCEP();
        })
    },
    watch: {

    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select
            id="projeto"
            class="form-control"
            v-model="solicitacao.rateio.idProjeto"
            data-vv-name="projeto"
            v-validate="'required'">
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacao) || projeto.acompanhamentoPendente || projeto.inativoDebito">
              {{ projeto.nomeProjeto }}

              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacao)">
                (Data limite até: {{ projeto.dataLimiteSolicitacao | formatarData }})
              </template>

              <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolicitacao) && !projeto.inativoDebito">
                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
              </template>

              <template v-if="projeto.inativoDebito">
                (Projeto bloqueado para solicitações, pois o projeto está inativo para débito)
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input
            type="text"
            class="form-control"
            v-model="solicitacao.rateio.projeto.nomeProjeto"
            disabled>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarDetalheRateio, {'has-error': errors.has('detalheRateio')}]">
          <label class="control-label" for="detalhe-rateio">Detalhe rateio</label>

          <select
            id="detalhe-rateio"
            class="form-control"
            v-model="solicitacao.rateio.idDetalheRateio"
            data-vv-name="detalheRateio"
            data-vv-as="detalhe rateio"
            v-validate="validarDetalheRateio">
            <option value="">Selecione...</option>
            <option :value="detalheRateio.id" v-for="detalheRateio in detalheRateios">{{ detalheRateio.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('detalheRateio')">{{ errors.first('detalheRateio') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.selecaoDeContaWeb">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarConta, {'has-error': errors.has('conta')}]">
          <label class="control-label" for="id-conta">Conta</label>

          <select
            id="id-conta"
            class="form-control"
            v-model="solicitacao.idConta"
            data-vv-name="conta"
            v-validate="validarConta">
            <option value="">{{ contas.length > 0 ? 'Selecione...' : 'Selecione o projeto' }}</option>
            <option :value="conta.id" v-for="conta in contas">{{ conta.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="solicitacao.rateio.projeto.utilizarMetaEtapaProjeto">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('metaEtapa')}">
          <label class="control-label" for="meta-etapa">Meta etapa</label>

          <select
            class="form-control"
            id="meta-etapa"
            v-model="solicitacao.rateio.idProjetoMetaEtapa"
            data-vv-name="metaEtapa"
            data-vv-as="meta etapa"
            v-validate="'required'"
            @change="listaDeRubricas(solicitacao.rateio.projeto.idProjeto)">
            <option value="">Selecione...</option>
            <option
              :value="metaEtapa.idProjetoMetaEtapa"
              v-for="(metaEtapa, index) in metaEtapas">
              {{ `${metaEtapa.meta.nome} - ${metaEtapa.etapa.nome}` }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('metaEtapa')">{{ errors.first('metaEtapa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="exibirRubricaSubrubricaSolicitacaoWeb">
      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select
            class="form-control"
            id="rubrica"
            v-model="solicitacao.idRubrica"
            data-vv-name="rubrica"
            data-vv-as="rubrica"
            v-validate="'required'"
            @change="listaDeSubrubricas">
            <option value="">Selecione...</option>
            <option
              :value="rubrica.id"
              v-for="rubrica in rubricas">
              {{ rubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select
            class="form-control"
            id="subrubrica"
            v-model="solicitacao.idSubrubrica"
            data-vv-name="subrubrica"
            data-vv-as="subrubrica"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option
              :value="subrubrica.id"
              v-for="subrubrica in subrubricas">
              {{ subrubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">
    
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nomeTerceiro')}">
          <label class="control-label" for="nome-terceiro">Nome do beneficiário</label>

          <input 
              type="text"
              class="form-control"
              id="nome-terceiro"
              v-model="solicitacao.nomeTerceiro"
              data-vv-name="nomeTerceiro"
              data-vv-as="Nome do beneficiário"
              v-validate="'required'"
              maxlength="100"
              :disabled="desabilitarBeneficiario">

          <p class="text-danger" v-show="errors.has('nomeTerceiro')">{{ errors.first('nomeTerceiro') }}</p>
        </div>
      </div>
      
      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="documento-terceiro">CNPJ do beneficiário</label>

          <input 
              type="text"
              class="form-control"
              id="documento-terceiro"
              v-model="solicitacao.documentoTerceiro"
              disabled>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="control-label" for="identidade">Inscrição estadual</label>

          <input
              id="identidade"
              class="form-control"
              type="text"
              v-model="solicitacao.identidade"
              maxlength="20">
        </div>
      </div>
      
      <div class="col-lg-6">
        <div class="form-group">
          <label class="control-label" for="inscricao-municipal">Inscrição municipal</label>

          <input
              id="inscricao-municipal"
              class="form-control"
              type="text"
              v-model="solicitacao.inscricaoMunicipal"
              maxlength="20">
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cep')}" id="dCep">
          <label class="control-label" for="cep">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="solicitacao.cep"
                 data-vv-as="cep"
                 data-vv-name="cep"
                 v-mascara="'cep'"
                 :disabled="desabilitarEndereco"
                 v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''">

          <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}" id="dEndereco">
          <label class="control-label" for="endereco">Endereço</label>

          <input id="endereco"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.endereco"
                 data-vv-name="endereco"
                 data-vv-as="endereço"
                 :disabled="desabilitarEndereco"
                 v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}" id="dNumero">
          <label class="control-label" for="numero">Número</label>

          <input id="numero"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.numero"
                 data-vv-name="numero"
                 data-vv-as="número"
                 v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
        </div>
      </div>      
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input id="complemento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.complemento"
                 maxlength="80">
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('bairro')}" id="dBairro">
          <label class="control-label" for="bairro">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="solicitacao.bairro"
                 data-vv-as="bairro"
                 data-vv-name="bairro"
                 :disabled="desabilitarEndereco"
                 v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}" id="dCidade">
          <label class="control-label" for="cidade">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="solicitacao.cidade"
                 data-vv-as="cidade"
                 data-vv-name="cidade"
                 :disabled="desabilitarEndereco"
                 v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('uf')}" id="dUf">
          <label class="control-label" for="uf">Estado</label>

          <select id="uf"
                  class="form-control"
                  v-model="solicitacao.uf"
                  data-vv-as="estado"
                  data-vv-name="uf"
                  :disabled="desabilitarEndereco"
                  v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('uf')">{{ errors.first('uf') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneResidencial')}" id="dTelefone-residencial">
          <label class="control-label" for="telefone-residencial">Telefone 1</label>

          <input
              type="text"
              class="form-control"
              id="telefone-residencial"
              v-mascara="'telefone'"
              v-model="solicitacao.telefoneResidencial"
              data-vv-as="telefone 1"
              data-vv-name="telefoneResidencial"
              v-validate="configuracao.solPagamentoMenosRestricao == 0 ? 'required' : ''">

          <p class="text-danger" v-show="errors.has('telefoneResidencial')">{{ errors.first('telefoneResidencial') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="telefone-comercial">Telefone 2</label>

          <input
              id="telefone-comercial"
              class="form-control"
              type="text"
              v-mascara="'telefone'"
              v-model="solicitacao.telefoneComercial">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="fax">Fax</label>

          <input
              id="fax"
              class="form-control"
              type="text"
              v-mascara="'telefone'"
              v-model="solicitacao.fax">
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('emailTerceiro')}" id="dEmail-terceiro">
          <label class="control-label" for="email-terceiro">E-mail do beneficiário <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input
              type="text"
              class="form-control"
              id="email-terceiro"
              v-model="solicitacao.emailTerceiro"
              data-vv-as="e-mail"
              data-vv-name="emailTerceiro"
              v-validate="configuracao.solPagamentoMenosRestricao == 0 ? `required|emailcomposto` : 'emailcomposto'"
              maxlength="300"
              v-caracteres-email>

          <p class="text-danger" v-show="errors.has('emailTerceiro')">{{ errors.first('emailTerceiro') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/juridica/componentes/compartilhado/FormDadosCadastrais.vue